module.exports = "/img/logo.5ac9dee2.png";